import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"

function TabTourses({
  dimension,
  correction,
  specification,
  field,
  onChangeDim,
  onChangeCor,
  onChangeSpec,
}) {
  return (
    <>
      <Card>
        <CardBody>
          <p>固定枠</p>
          <Row>
            <Col xl={8} sm={12}>
              <Row>
                <Col sm={6} className="pe-0">
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">店舗</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">受注日</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">顧客名</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">生地商社</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">生地</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">生地ランク</p>
                        </td>
                        <td
                          style={{ padding: 5 }}
                          className="d-flex align-items-center justify-content-between"
                        >
                          <input disabled className="form-control" />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p className="mb-0">生地巾</p>
                        </td>
                        <td
                          style={{ padding: 5 }}
                          className="d-flex align-items-center justify-content-between"
                        >
                          <input disabled className="form-control" />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">仮縫い日</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">釦</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">プライス税別</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                <Col sm={6} className="ps-0">
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td>
                          <p className="mb-0">種別</p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div>
                              <Input
                                disabled
                                className="me-2 me-xl-1"
                                type="radio"
                              />
                              <Label className="mb-0">Bespoke</Label>
                            </div>

                            <div className="ms-5 ms-xl-3">
                              <Input
                                disabled
                                className="me-2 me-xl-1"
                                type="radio"
                              />
                              <Label className="mb-0">MTM</Label>
                            </div>
                            <div className="ms-5 ms-xl-3">
                              <Input
                                disabled
                                className="me-2 me-xl-1"
                                type="radio"
                              />
                              <Label className="mb-0">RTW</Label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <Input disabled style={{ opacity: 0 }} type="radio" />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 128 }}>
                              <Input disabled type="checkbox" />
                              <Label className="ms-2 mb-0">ゲスト</Label>
                            </div>

                            <input
                              placeholder="ゲスト名を入力"
                              style={{ height: 33 }}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 4 }}>
                          <div className="d-flex align-items-center">
                            <Label style={{ width: 120 }} className="ms-2 mb-0">
                              生地年度
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control w-100"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex align-items-center">
                            <Label
                              style={{
                                width: 120,
                                fontSize: 12,
                                textAlign: "center",
                              }}
                              className="me-2 mb-0"
                            >
                              生地シーズン
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control w-100"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                混率
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={2}
                          style={{ padding: 6.5, position: "relative" }}
                        >
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                用尺
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                            <p
                              style={{
                                position: "absolute",
                                right: 15,
                                top: 10,
                                opacity: 0.5,
                              }}
                            >
                              M
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: 107 }}>
                          <p className="mb-0">仮縫い</p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div>
                              <Input disabled className="me-2" type="radio" />
                              <Label className="mb-0">あり</Label>
                            </div>

                            <div className="ms-5">
                              <Input disabled className="me-2" type="radio" />
                              <Label className="mb-0">なし</Label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5.5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 100 }}
                                className="ms-2 mb-0"
                              >
                                糸色
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 100 }}
                                className="ms-2 mb-0"
                              >
                                プライス税込
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Col>
            <Col xl={4} sm={6}>
              <Row>
                <Col>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td>ステータス</td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                      <tr>
                        <td>下代<br/><small>※直販の場合は上代と同金額です</small></td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                      <tr>
                        <td>予定納品日</td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                      <tr>
                        <td>出来上日</td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                      <tr>
                        <td>製作者</td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Row>
            <Col xl={8} sm={12}>
              <p>寸法</p>
              <Table bordered>
                <tbody>
                  <tr>
                    <td>
                      <input
                        className="form-control"
                        disabled
                        placeholder="Tg"
                      />
                    </td>
                    <td>ヌード</td>
                    <td>補正値</td>
                    <td>上り寸</td>
                  </tr>
                  {field?.pants && field.pants.dimensions.length > 0 ? (
                    field.pants.dimensions.map((v, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ minWidth: 250 }}>
                            <SelectBox
                              options={dimension}
                              onChange={e => onChangeDim(e, i)}
                              value={dimension.find(s => s.value === v.formId)}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              disabled
                              // value={v.formId ? v.item : ""}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              disabled
                              // value={v.formId ? v.sequence : ""}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              disabled
                              // value={v.formId ? v.frameType : ""}
                            />
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td style={{ minWidth: 250 }}>
                        <SelectBox
                          options={dimension}
                          onChange={e => onChangeDim(e, 0)}
                        />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
            <Col xl={4} sm={6}>
              <p>補正</p>
              <Table bordered>
                <tbody>
                  {field?.pants && field.pants.corrections.length > 0 ? (
                    field.pants.corrections.map((v, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ minWidth: 180 }}>
                            <SelectBox
                              value={correction.find(s => s.value === v.formId)}
                              onChange={e => onChangeCor(e, i)}
                              options={correction}
                            />
                          </td>
                          <td>
                            {v.format === "チェックボックス" ? ( // checkbox
                              <div className="d-flex justify-content-start gap-4">
                                {v.labels.map(label => {
                                  return (
                                    <div key={label.label}>
                                      <Input
                                        className="me-2"
                                        type="checkbox"
                                        value={label.sequence}
                                        data-answer={label.label}
                                        checked={v.answer === label.sequence}
                                        disabled
                                      />
                                      <Label className="mb-0">
                                        {label.label}
                                      </Label>
                                    </div>
                                  )
                                })}
                              </div>
                            ) : v.format === "プルダウン" ? (
                              <div style={{ width: "100%" }}>
                                <SelectBox
                                  options={v.labels.map(l => ({
                                    label: l.label,
                                    value: l.sequence,
                                  }))}
                                  value={v.labels.filter(
                                    s => s.sequence === v.answer
                                  )}
                                  isDisabled
                                />
                              </div>
                            ) : v.format === "ラジオボタン" ? (
                              <div className="d-flex">
                                {v.labels.map(l => {
                                  return (
                                    <div
                                      className="d-flex me-2"
                                      key={l.sequence}
                                    >
                                      <Input
                                        name={`${v.formId}${i}`}
                                        className="me-2"
                                        type="radio"
                                        checked={l.sequence === v.answer}
                                        value={l.sequence}
                                      />
                                      <Label>{l.label}</Label>
                                    </div>
                                  )
                                })}
                              </div>
                            ) : (
                              <input className="form-control" disabled />
                            )}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td style={{ minWidth: 180 }}>
                        <SelectBox
                          onChange={e => onChangeCor(e, 0)}
                          options={correction}
                          o
                        />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Row style={{ overflow: "auto" }}>
            <Col xl={8} sm={12}>
              <p>仕様枠</p>
              <Table bordered>
                <tbody>
                  {field?.pants && field.pants.specifications.length > 0 ? (
                    field.pants.specifications.map((v, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <SelectBox
                              value={specification.find(
                                s => s.value === v.formId
                              )}
                              onChange={e => onChangeSpec(e, i)}
                              options={specification}
                            />
                          </td>
                          <td>
                            <Row className="gy-3">
                              {v.format === "チェックボックス" ? ( // checkbox
                                <div className="d-flex justify-content-start gap-4">
                                  {v.labels.map(label => {
                                    return (
                                      <div key={label.label}>
                                        <Input
                                          className="me-2"
                                          type="checkbox"
                                          value={label.sequence}
                                          data-answer={label.label}
                                          checked={v.answer === label.sequence}
                                          disabled
                                        />
                                        <Label className="mb-0">
                                          {label.label}
                                        </Label>
                                      </div>
                                    )
                                  })}
                                </div>
                              ) : v.format === "プルダウン" ? (
                                <div style={{ width: "100%" }} className="mx-2">
                                  <SelectBox
                                    options={v.labels.map(l => ({
                                      label: l.label,
                                      value: l.sequence,
                                    }))}
                                    value={v.labels.filter(
                                      s => s.sequence === v.answer
                                    )}
                                    isDisabled
                                  />
                                </div>
                              ) : v.format === "ラジオボタン" ? (
                                <div className="d-flex">
                                  {v.labels.map(l => {
                                    return (
                                      <div
                                        className="d-flex me-2"
                                        key={l.sequence}
                                      >
                                        <Input
                                          name={`${v.formId}${i}`}
                                          className="me-2"
                                          type="radio"
                                          checked={l.sequence === v.answer}
                                          value={l.sequence}
                                        />
                                        <Label>{l.label}</Label>
                                      </div>
                                    )
                                  })}
                                </div>
                              ) : (
                                <input
                                  className="form-control"
                                  disabled
                                  value={v.item}
                                />
                              )}
                            </Row>
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td>
                        <SelectBox
                          onChange={e => onChangeSpec(e, 0)}
                          options={specification}
                        />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  )
}

export default TabTourses
